// UPIM Mock Data - Datos simulados para desarrollo
// Este archivo será reemplazado por datos reales del backend

export const mockStats = {
  propiedadesRenta: 1250,
  propiedadesVenta: 3480,
  afiliados: 2150,
  estados: 32
};

export const mockEvents = [
  {
    id: '1',
    title: 'Prevención de Fraudes Inmobiliarios',
    date: '2025-08-15',
    time: '10:00',
    location: 'Centro de Convenciones CDMX',
    type: 'presencial',
    image: 'https://images.unsplash.com/photo-1762758731234-2569e31afa02?w=800',
    description: 'Aprende a identificar y prevenir fraudes en transacciones inmobiliarias',
    spots: 150,
    spotsAvailable: 45,
    price: 0
  },
  {
    id: '2',
    title: 'Real Estate Technology 2025',
    date: '2025-09-20',
    time: '09:00',
    location: 'World Trade Center CDMX',
    type: 'presencial',
    image: 'https://images.unsplash.com/photo-1765573190211-bf5d0bdd5a2d?w=800',
    description: 'El evento tecnológico inmobiliario más importante de México',
    spots: 500,
    spotsAvailable: 120,
    price: 1500
  },
  {
    id: '3',
    title: 'Master Class: Marketing Digital Inmobiliario',
    date: '2025-07-28',
    time: '18:00',
    location: 'Online - Zoom',
    type: 'online',
    image: 'https://images.unsplash.com/photo-1769490314500-13261e906d3c?w=800',
    description: 'Estrategias de marketing digital para el sector inmobiliario',
    spots: 200,
    spotsAvailable: 80,
    price: 0
  },
  {
    id: '4',
    title: 'Certificación CONOCER EC0110.02',
    date: '2025-08-05',
    time: '09:00',
    location: 'Oficinas UPIM - Nápoles',
    type: 'presencial',
    image: 'https://images.unsplash.com/photo-1610650394144-a778795cf585?w=800',
    description: 'Certifícate oficialmente como asesor inmobiliario profesional',
    spots: 30,
    spotsAvailable: 8,
    price: 3479
  }
];

export const mockBenefits = [
  {
    id: '1',
    title: 'Eventos Inmobiliarios',
    description: 'Sé parte de nuestro evento anual REAL ESTATE TECHNOLOGY y otros eventos exclusivos.',
    icon: 'Calendar',
    category: 'eventos'
  },
  {
    id: '2',
    title: 'Master Classes',
    description: 'Participa en las Master Classes quincenales para formarte y actualizarte como profesional.',
    icon: 'GraduationCap',
    category: 'formacion'
  },
  {
    id: '3',
    title: 'Asesoría Jurídica',
    description: 'Únete a nuestro chat para resolver dudas sobre arrendamiento, compra-venta y temas legales.',
    icon: 'Scale',
    category: 'asesoria'
  },
  {
    id: '4',
    title: 'Grupos de WhatsApp',
    description: 'Acceso a grupos por zona geográfica para networking y oportunidades de negocio.',
    icon: 'MessageCircle',
    category: 'networking'
  },
  {
    id: '5',
    title: 'Comité de Mujeres',
    description: 'Iniciativa para fortalecer el apoyo a mujeres profesionales del sector inmobiliario.',
    icon: 'Users',
    category: 'comunidad'
  },
  {
    id: '6',
    title: 'Red Inmobiliaria',
    description: 'Conecta con una red de asesores y haz comunidad y networking.',
    icon: 'Network',
    category: 'networking'
  },
  {
    id: '7',
    title: 'Protocolos NOM-247',
    description: 'Descarga el material que solicita la norma para tus operaciones de compra-venta.',
    icon: 'FileText',
    category: 'recursos'
  },
  {
    id: '8',
    title: 'Contrato Modelo NOM-247',
    description: 'Acceso a contratos modelo que cumplen con la normativa vigente.',
    icon: 'FileCheck',
    category: 'recursos'
  },
  {
    id: '9',
    title: 'Asesoría Financiera',
    description: 'Solicita una asesoría gratuita en temas financieros para tus clientes.',
    icon: 'DollarSign',
    category: 'asesoria'
  },
  {
    id: '10',
    title: 'Asesoría Contable y Fiscal',
    description: 'Asesoría sin costo en temas contables, fiscales y administrativos.',
    icon: 'Calculator',
    category: 'asesoria'
  },
  {
    id: '11',
    title: 'INFONAVIT & FOVISSSTE',
    description: 'Gestión de trámites con costo preferencial de $10,000 por trámite.',
    icon: 'Home',
    category: 'servicios'
  },
  {
    id: '12',
    title: 'Avalúos',
    description: 'Costos preferenciales desde $2,500 a $3,500 en avalúos certificados.',
    icon: 'ClipboardCheck',
    category: 'servicios'
  },
  {
    id: '13',
    title: 'Dictamen Estructural',
    description: 'Dictamen emitido por D.R.O. según la norma NOM-247-SE202.',
    icon: 'Building',
    category: 'servicios'
  },
  {
    id: '14',
    title: 'Certificación Inmobiliaria',
    description: 'EC0110.02 Asesoría en comercialización de bienes inmuebles con descuento especial.',
    icon: 'Award',
    category: 'formacion'
  },
  {
    id: '15',
    title: 'Descuento Mercado Libre',
    description: '38% de descuento en paquetes de publicación de propiedades.',
    icon: 'Tag',
    category: 'descuentos'
  },
  {
    id: '16',
    title: 'Morgana',
    description: '0.5% de comisión por crédito colocado a través de la plataforma.',
    icon: 'CreditCard',
    category: 'servicios'
  },
  {
    id: '17',
    title: 'Biblioteca Digital',
    description: 'Templates de publicidad, contratos, formatos, Master Classes y Ebooks.',
    icon: 'Library',
    category: 'recursos'
  },
  {
    id: '18',
    title: 'Seguro de Gastos Médicos',
    description: 'Seguro colectivo para asesores a precios especiales.',
    icon: 'Heart',
    category: 'servicios'
  }
];

export const mockMembershipPlans = [
  {
    id: 'proveedor',
    name: 'Proveedor Certificado',
    price: 5000,
    period: 'anual + IVA',
    description: 'Membresía para proveedores de servicios certificados por UPIM',
    features: [
      'Posibilidad de dar una Master Class al mes',
      'Promocionar servicios tras firmar contrato',
      'Acceso a base de datos de socios',
      'Agregar valor real y único a los afiliados',
      'Certificación de infraestructura y trayectoria',
      'Garantía de certeza en tiempo, forma y calidad',
      'Presencia en carrusel de proveedores web',
      'Exposición ante +2,000 profesionales'
    ],
    popular: false,
    badge: 'Proveedores'
  },
  {
    id: 'titular',
    name: 'Membresía Titular',
    price: 3500,
    period: 'anual',
    description: 'Membresía completa con todos los beneficios UPIM',
    features: [
      'Acceso a todos los beneficios UPIM',
      'Credencial digital con QR',
      'Asesoría jurídica ilimitada',
      'Master Classes quincenales',
      'Acceso a biblioteca digital',
      'Grupos de WhatsApp por zona',
      'Descuentos en certificaciones',
      'Acceso a eventos exclusivos'
    ],
    popular: true
  },
  {
    id: 'sub-1-5',
    name: 'Sub-afiliación (1-5)',
    price: 1000,
    period: 'anual',
    description: 'Para equipos de 1 a 5 personas (requiere titular)',
    features: [
      'Todos los beneficios de afiliado',
      'Credencial digital individual',
      'Acceso a capacitaciones',
      'Networking con otros afiliados'
    ],
    popular: false
  },
  {
    id: 'sub-5-25',
    name: 'Sub-afiliación (5-25)',
    price: 800,
    period: 'anual',
    description: 'Para equipos de 5 a 25 personas (requiere titular)',
    features: [
      'Todos los beneficios de afiliado',
      'Credencial digital individual',
      'Acceso a capacitaciones',
      'Descuento por volumen'
    ],
    popular: false
  },
  {
    id: 'sub-25+',
    name: 'Sub-afiliación (25+)',
    price: 500,
    period: 'anual',
    description: 'Para equipos de más de 25 personas (requiere titular)',
    features: [
      'Todos los beneficios de afiliado',
      'Credencial digital individual',
      'Mejor precio por volumen',
      'Soporte prioritario'
    ],
    popular: false
  },
  {
    id: 'certificacion',
    name: 'Certificación CONOCER',
    price: 3479,
    priceNoMember: 4639,
    period: 'único',
    description: 'EC0110.02 Asesoría en comercialización de bienes inmuebles',
    features: [
      '8 horas de taller de alineación',
      'Evaluación oficial (3 horas)',
      'Certificado CONOCER oficial',
      'Material de estudio incluido'
    ],
    popular: false
  },
  {
    id: 'paquete-completo',
    name: 'Afiliación + Certificación',
    price: 5916,
    period: 'único',
    description: 'Paquete completo: membresía titular más certificación',
    features: [
      'Membresía titular anual',
      'Certificación EC0110.02',
      'Ahorro de más de $1,000',
      'Proceso simplificado'
    ],
    popular: false
  }
];

export const mockProviders = [
  {
    id: '1',
    name: 'Notaría 125 CDMX',
    category: 'Servicios Notariales',
    description: 'Servicios notariales especializados en operaciones inmobiliarias',
    logo: 'https://ui-avatars.com/api/?name=N125&background=374151&color=fff&size=200',
    location: 'Ciudad de México',
    discount: '15% en escrituración',
    rating: 4.8,
    verified: true,
    services: ['Escrituración', 'Poderes', 'Testamentos', 'Constitución de sociedades']
  },
  {
    id: '2',
    name: 'Avalúos Profesionales MX',
    category: 'Avalúos',
    description: 'Avalúos certificados para todo tipo de inmuebles',
    logo: 'https://ui-avatars.com/api/?name=APM&background=374151&color=fff&size=200',
    location: 'Nacional',
    discount: '$2,500 - $3,500 precio preferencial',
    rating: 4.9,
    verified: true,
    services: ['Avalúos comerciales', 'Avalúos habitacionales', 'Avalúos industriales']
  },
  {
    id: '3',
    name: 'Créditos Hipotecarios Express',
    category: 'Financiamiento',
    description: 'Gestión de créditos hipotecarios con las mejores tasas',
    logo: 'https://ui-avatars.com/api/?name=CHE&background=374151&color=fff&size=200',
    location: 'Nacional',
    discount: '0.5% comisión UPIM',
    rating: 4.7,
    verified: true,
    services: ['Créditos bancarios', 'INFONAVIT', 'FOVISSSTE', 'Cofinanciamiento']
  },
  {
    id: '4',
    name: 'Seguros Inmobiliarios Pro',
    category: 'Seguros',
    description: 'Seguros especializados para el sector inmobiliario',
    logo: 'https://ui-avatars.com/api/?name=SIP&background=374151&color=fff&size=200',
    location: 'Nacional',
    discount: '20% en pólizas anuales',
    rating: 4.6,
    verified: true,
    services: ['Seguro de hogar', 'RC profesional', 'Gastos médicos colectivos']
  },
  {
    id: '5',
    name: 'Marketing Digital Inmobiliario',
    category: 'Marketing',
    description: 'Estrategias de marketing digital para asesores inmobiliarios',
    logo: 'https://ui-avatars.com/api/?name=MDI&background=374151&color=fff&size=200',
    location: 'Nacional',
    discount: '25% en paquetes mensuales',
    rating: 4.8,
    verified: true,
    services: ['Redes sociales', 'Fotografía inmobiliaria', 'Tours virtuales', 'SEO']
  },
  {
    id: '6',
    name: 'Despacho Jurídico Inmobiliario',
    category: 'Legal',
    description: 'Asesoría legal especializada en derecho inmobiliario',
    logo: 'https://ui-avatars.com/api/?name=DJI&background=374151&color=fff&size=200',
    location: 'Ciudad de México',
    discount: 'Primera consulta gratis',
    rating: 4.9,
    verified: true,
    services: ['Contratos', 'Litigios', 'Due diligence', 'Regularización']
  }
];

export const mockProviderCategories = [
  'Todos',
  'Servicios Notariales',
  'Avalúos',
  'Financiamiento',
  'Seguros',
  'Marketing',
  'Legal',
  'Tecnología',
  'Capacitación'
];

export const mockWhatsAppGroups = [
  { id: '1', name: 'BUSCO/OFREZCO UPIM – Zona Oriente', link: 'https://chat.whatsapp.com/GDNE4tcho79LRHovUY2pMY', members: 245 },
  { id: '2', name: 'BUSCO/OFREZCO UPIM – Zona Poniente', link: 'https://chat.whatsapp.com/JfbaYW02UoH8fpTE51CXuX', members: 312 },
  { id: '3', name: 'BUSCO/OFREZCO UPIM – Zona Centro', link: 'https://chat.whatsapp.com/KIF4Gw0fVZ41JM3dOKbTf8', members: 428 },
  { id: '4', name: 'BUSCO/OFREZCO UPIM – Zona Norte', link: 'https://chat.whatsapp.com/IbtXcZ5fQ0KE9p2PUI0xeM', members: 189 },
  { id: '5', name: 'BUSCO/OFREZCO UPIM – Zona Sur', link: 'https://chat.whatsapp.com/JZLatNZ9j0VKW4NsQJQVqI', members: 267 },
  { id: '6', name: 'BUSCO/OFREZCO – Edomex', link: 'https://chat.whatsapp.com/JS33UiixKhP2jBEZjkFmPv', members: 356 },
  { id: '7', name: 'BUSCO/OFREZCO – Foráneos', link: 'https://chat.whatsapp.com/BAy8GEne4vK2xkfbyLwh5J', members: 198 },
  { id: '8', name: 'Asesoría Jurídica', link: 'https://chat.whatsapp.com/Df7VRE2j5rH3mUdw3qIxJw', members: 520 },
  { id: '9', name: 'UPIM Abierto', link: 'https://chat.whatsapp.com/FsAJpw7c7UKIntokI1n6Cm', members: 890 }
];

export const mockDocuments = [
  { id: '1', name: 'Directorio UPIM', type: 'pdf', url: 'https://upim.org/wp-content/uploads/2024/02/Directorio-UPIM-documento.pdf', category: 'institucional' },
  { id: '2', name: 'Código de Ética', type: 'pdf', url: 'https://upim.org/wp-content/uploads/2023/10/CODIGO-HONOR-Y-JUSTICIA-UPIM.doc.pdf', category: 'institucional' },
  { id: '3', name: 'Manual de Afiliación', type: 'pdf', url: 'https://upim.org/wp-content/uploads/2023/10/MANUAL-DE-AFILIACION-UPIM-2023.pdf', category: 'afiliacion' },
  { id: '4', name: 'Contrato Modelo NOM-247', type: 'pdf', url: '#', category: 'contratos' },
  { id: '5', name: 'Protocolo de Compra-Venta', type: 'pdf', url: '#', category: 'protocolos' }
];

export const mockCourses = [
  {
    id: '1',
    title: 'Certificación EC0110.02',
    instructor: 'Lic. María González',
    duration: '11 horas',
    modules: 3,
    image: 'https://images.unsplash.com/photo-1610650394144-a778795cf585?w=800',
    description: 'Certifícate oficialmente como asesor inmobiliario profesional',
    price: 3479,
    level: 'Intermedio',
    category: 'Certificación'
  },
  {
    id: '2',
    title: 'Marketing Digital para Inmobiliarios',
    instructor: 'Mtro. Carlos Ramírez',
    duration: '6 horas',
    modules: 8,
    image: 'https://images.unsplash.com/photo-1769490314500-13261e906d3c?w=800',
    description: 'Domina las estrategias de marketing digital para vender más',
    price: 0,
    level: 'Básico',
    category: 'Marketing'
  },
  {
    id: '3',
    title: 'Aspectos Legales en Bienes Raíces',
    instructor: 'Lic. Roberto Hernández',
    duration: '4 horas',
    modules: 5,
    image: 'https://images.unsplash.com/photo-1721244654346-9be0c0129e36?w=800',
    description: 'Todo lo que necesitas saber sobre contratos y regulaciones',
    price: 0,
    level: 'Intermedio',
    category: 'Legal'
  },
  {
    id: '4',
    title: 'INFONAVIT y FOVISSSTE Avanzado',
    instructor: 'Lic. Ana Martínez',
    duration: '3 horas',
    modules: 4,
    image: 'https://images.unsplash.com/photo-1757262798677-ab4af4455a58?w=800',
    description: 'Maximiza las oportunidades con créditos gubernamentales',
    price: 0,
    level: 'Avanzado',
    category: 'Financiamiento'
  }
];

export const mockWebinars = [
  {
    id: '1',
    title: 'Tendencias del Mercado Inmobiliario 2025',
    date: '2025-07-30',
    time: '18:00',
    host: 'UPIM Nacional',
    status: 'upcoming',
    attendees: 145,
    description: 'Análisis de las tendencias actuales y proyecciones para el sector'
  },
  {
    id: '2',
    title: 'Cómo Cerrar Ventas de Alto Valor',
    date: '2025-08-06',
    time: '19:00',
    host: 'UPIM Nacional',
    status: 'upcoming',
    attendees: 89,
    description: 'Técnicas probadas para cerrar ventas de propiedades premium'
  }
];

export const mockUser = {
  id: '1',
  name: 'Juan Pérez García',
  email: 'juan.perez@email.com',
  phone: '55 1234 5678',
  role: 'affiliate', // 'affiliate', 'provider', 'admin', 'superadmin'
  membership: {
    plan: 'titular',
    status: 'active', // 'active', 'expiring', 'expired', 'grace', 'suspended'
    startDate: '2024-07-15',
    endDate: '2025-07-15',
    daysRemaining: 10
  },
  qrCode: 'UPIM-2024-001234',
  avatar: null,
  address: 'Ciudad de México',
  company: 'Inmobiliaria Pérez',
  certifications: ['EC0110.02']
};

export const mockMessages = [
  {
    id: '1',
    title: 'Recordatorio: Tu membresía vence pronto',
    content: 'Tu membresía UPIM vence en 10 días. Renueva ahora para mantener todos tus beneficios.',
    date: '2025-07-20',
    read: false,
    type: 'warning'
  },
  {
    id: '2',
    title: 'Nuevo evento: Prevención de Fraudes',
    content: 'Te invitamos al taller de Prevención de Fraudes Inmobiliarios el 15 de agosto.',
    date: '2025-07-18',
    read: true,
    type: 'event'
  },
  {
    id: '3',
    title: 'Bienvenido a UPIM',
    content: 'Gracias por unirte a la Unión de Profesionales Inmobiliarios de México.',
    date: '2024-07-15',
    read: true,
    type: 'info'
  }
];

export const mockPayments = [
  {
    id: '1',
    concept: 'Membresía Titular Anual',
    amount: 3500,
    date: '2024-07-15',
    status: 'paid',
    invoice: 'UPIM-2024-00123'
  },
  {
    id: '2',
    concept: 'Certificación EC0110.02',
    amount: 3479,
    date: '2024-09-10',
    status: 'paid',
    invoice: 'UPIM-2024-00456'
  }
];

export const mockAdminStats = {
  totalAffiliates: 2150,
  activeAffiliates: 1890,
  expiringThisMonth: 45,
  newThisMonth: 67,
  totalProviders: 48,
  verifiedProviders: 42,
  totalRevenue: 485000,
  revenueThisMonth: 52000,
  pendingPayments: 12,
  totalEvents: 24,
  upcomingEvents: 8
};

export const companyInfo = {
  name: 'Unión de Profesionales Inmobiliarios de México A.C.',
  shortName: 'UPIM',
  founded: 2016,
  address: 'Av. Insurgentes Sur 1602, Col-Piso 4, Crédito Constructor, Benito Juárez, 03940 Ciudad de México, CDMX',
  phone: '5571164745',
  email: 'info@upim.org',
  website: 'www.upim.org',
  social: {
    facebook: 'https://www.facebook.com/upimnacional',
    instagram: 'https://www.instagram.com/upimnacional/',
    twitter: 'https://twitter.com/upimnacional',
    whatsapp: 'https://wa.me/525571164745'
  },
  mission: 'Formalizar y profesionalizar al sector inmobiliario para la creación de empresas con amplia trayectoria, procurar la unidad y ayuda mutua en la planeación de un desarrollo lícito y responsable en el sector.',
  vision: 'Establecer lineamientos, estrategias y cursos de acción que favorezcan la regulación de la comercialización y la inversión inmobiliaria a través las agencias inmobiliarias y profesionales inmobiliarios.',
  values: ['Integridad', 'Compromiso', 'Profesionalismo', 'Solidaridad', 'Honestidad'],
  description: 'La Unión de Profesionales Inmobiliarios de México A.C. (UPIM) es la mejor plataforma en el mercado inmobiliario para la realización de negocios, ofreciendo proyectos de alto nivel y direcciones que apoyan al asesor en cada área relacionada a nuestra profesión.'
};
